import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClientService } from 'src/app/core/http/http-client';
import { Store } from 'src/app/core/store/store';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class PathwayService {
  constructor(private http: HttpClientService, private store: Store) { }
  
  get(programId, exerciseId, activationId,exerciseType) {
    return this.http.get<{ data: any[], result: number, msg: string }>(`ipj/user-pre-post-exercises/get?programId=${programId}&exerciseId=${exerciseId}&activationId=${activationId}&exerciseType=${exerciseType}`).pipe(
      map(res => {
        return res.data;
      }),
      catchError(err => {
        return [err];
      })
    )
  }

  getPost(programId, exerciseId, activationId,exerciseType) {
    return this.http.get<{ data: any[], result: number, msg: string }>(`ipj/user-pre-post-exercises/get?programId=${programId}&exerciseId=${exerciseId}&activationId=${activationId}&exerciseType=${exerciseType}`).pipe(
      map(res => {
        console.log(res,"lhuuuu");
        return res.data;
      }),
      catchError(err => {
        return [err];
      })
    )
  }

  getById(id: string) {
    return this.http.get<{ data: any[], result: number, msg: string }>(`user-pre-post-exercises/${id}`).pipe(
      map(res => {
        return res.data;
      }),
      catchError(err => {
        return [err];
      })
    )
  }

  /**
   * Get pre/post exercise data
   * @param data 
   */
  getPrePostExercise(id) {
    return this.http.get<{ data: any, result: number, msg: string }>(`exercise/${id}`).pipe(map(res => res.data));
  }
  
  /**
   * Save banchmarking pre/post exercises
   * @param data 
   */
  saveBenchmarkingPrePostExer(data) {
    return this.http.post<{ data: any, result: number, msg: string }>(`ipj/user-pre-post-exercises/save`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        return [err];
      })
    );
  }
  
  /**
   * Submit benchmarking pre/post exercise
   */
  submitPrePostExercise(data) {
    return this.http.post<{ data: User, result: number, msg: string }>(`ipj/user-pre-post-exercises/submit`, data).pipe(map(res => {
      // this.store.set(`user`, res.data);
      return res.data;
    }));
  }

  /**
   * Get pre/post data 
   * @param pid pathway id  
   * @param eid exercise id
   */
  getPrePostData(programId, exerciseId) {
    return this.http.get<{ data: any, result: number, msg: string }>(`ipj/user-pre-post-exercises/get?programId=${programId}&exerciseId=${exerciseId}`).pipe(map(res => res.data));
  }

  /**
   * Get pathway pre/post progress
   * @param pid 
   */
  getPathwayPrePostProgress(pid) {
    return this.http.get<{ data: any, result: number, msg: string }>(`ipj/user-pre-post-exercises/pathway-progress?pathwayId=${pid}`).pipe(map(res => res.data));
  }
// Total score
  getPathwayPostScore(programId,activationId) {
    return this.http.get<{ data: any, result: number, msg: string }>(`ipj/user-pre-post-exercises/post-complete-score?programId=${programId}&activationId=${activationId}`).pipe(map(res => res.data));
  }
//end
  getPathwayTotalProgess(pid) {
    return this.http.get<{ data: any, result: number, msg: string }>(`user-pre-post-exercises?pathwayId=${pid}`).pipe(map(res => res.data));
  }

  generatePathwayCertificate(pathwayId) {
    return this.http.get<{ data: User, result: number, msg: string }>(`user-pre-post-exercises/generatePathwayCertificate?pathwayId=${pathwayId}`).pipe(map(res => {
      if(res.data && res.data.pathwayCertificateInfo.length) {
        this.store.set(`pathwayCertificateGenerated`, true);
      }
      return res.data;
    }));
  }

  // Get post exercise data for modular IPJ programs
  getPrePostExerData(programId, exerciseId, activationId, exerciseType) {
    return this.http.get<{ data: any[], result: number, msg: string }>(`ipj/user-pre-post-exercises/post-complete-score?programId=${programId}&exerciseId=${exerciseId}&activationId=${activationId}&exerciseType=${exerciseType}`).pipe(
      map(res => {
        return res.data;
      }),
      catchError(err => {
        return [err];
      })
    )
  }

  getAssessmentData(activationId, programDashboardId, exerciseId) {
    return this.http.get<{ data: any[], result: number, msg: string }>(`ipj/user-progress/assessment?programActivationId=${activationId}&programDashboardId=${programDashboardId}&exerciseId=${exerciseId}`).pipe(
      map(res => {
        return res.data;
      }),
      catchError(err => {
        return [err];
      })
    )
  }

  saveAssessmentExer(data) {
    return this.http.put<{ data: any, result: number, msg: string }>(`ipj/user-progress/assessment`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        return [err];
      })
    );
  }
  
}
